var _desc, _defs, _g, _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoftware(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.2.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 0 0)",
    id: "d46d048b-940b-4a85-b8ef-321388a72f48"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 640 360)",
    id: "48ea9d12-bab6-4021-b337-32bacb8baa6f"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(42,157,143)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -640,
    y: -360,
    rx: 0,
    ry: 0,
    width: 1280,
    height: 720
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 640 360)",
    style: {},
    id: "22b424a6-31bc-4788-8cc6-d663e65ca9fa"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    fontFamily: "Lato",
    fontSize: 200,
    fontStyle: "normal",
    fontWeight: 900,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1,
      whiteSpace: "pre"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -419.3,
    y: 62.83
  }, "Software")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftware);
export default __webpack_public_path__ + "static/media/software.a2322bcbc55b005a324d4eaafe6b1acd.svg";
export { ForwardRef as ReactComponent };